<template>
<div   class="container-fluid">

<spinner v-bind:spinner='spinner'></spinner>

  <div class="row">
  <div class="col">

    <confirm-box v-if="cb.show">
      <template v-slot:header>
      <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body>
        {{cb.msg1}}   
      </template>
        <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">NO</button>
        <button @click="setConfirmBox(),cb.show=false" type="button" class="btn btn-primary">SI</button>
    </template>    
    </confirm-box>
          
  <div class="card border-primary">
  <div  class="card-header bg-primary text-white">
    <h4 style="color:white"> <i  class="fas fa-external-link-alt mr-3" aria-hidden="true"></i>INVIO ORDINE A STAMPANTE SDP EPSON</h4>
  </div>  

  <div class="card-body">
  <alert-box  class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
  
  <div class="row">
    
    <div class="col-4">
      <ordersList></ordersList>
    </div>


    <div class="col-2">
    <form v-on:submit.prevent="submit()">  
    
    <div class="col-sm">
      <mp-select :key="refresh"  class="" v-bind:props="mp" @update="setMPId"></mp-select>
    </div>
    
    <div class="col-sm">
      <label><strong>NUMERO ORDINE</strong></label>
      <input autocomplete="off" v-model="orderId" required type="text" class="form-control"  placeholder="Numero ordine">
    </div>
    <div class="col-sm mt-2">
      <label for="date_doc"><strong>DATA ORDINE </strong></label>
      <input  required v-model="orderDate" type="date" class="form-control" placeholder="Data ordine" >     
    </div>  
    <div class="col-sm mt-2">
      <label><strong>ORARIO</strong></label>
      <input v-model="orderTime" type="text" class="form-control"  placeholder="Orario ordine">      
    </div>
    <div class="col-sm mt-4">
      <label><strong>CODICE A BARRE</strong></label>
      <input autocomplete="off" required type="text" v-model="barcode" class="form-control" id="inlineFormInput" placeholder="Codice a barre">
    </div>
    <div class="row mt-2 mr-4">
      <div class="col text-right">
        <!--
        <button ref="search" @click="reset()"  type="button" class="btn btn-secondary mr-1">    
            <i class="fas fa-sync mr-2" aria-hidden="true"></i>
            RESET 
        </button>  
        -->
      <button :disabled="spinner" type="submit"  class="btn btn-success ">
          <i class="fas fa-binoculars mr-2"></i>
            CERCA
            <span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>   
      </div>

      
    </div>
  </form>
  </div>
   

    <div class="col-6 mt-4">

      <div  class="scroll table-wrapper-scroll-y my-custom-scrollbar mt-1">

<table  class="cart table table-hover table-sm mb-0" id="shoppingCart">
<thead>
  <tr  class="table-active">
    
    <th></th>
    <th>#</th>  
    <th class="text-nowrap">NUM. ORDINE</th>  
    <th>EAN</th>
    
    <th>BRAND</th>
    <th>CODICE</th>         
    <th>DESCRIZIONE</th>
    
    <th>COLORE</th>
    <th>MISURA</th>
    <th class="text-right">STOCK</th>
    <th class="text-right text-nowrap">PREZZO RETAIL</th>
    <th class="text-right">SCONTO</th>
    <th class="text-right text-nowrap">PREZZO DI VENDITA</th>
    
  
  </tr>
  </thead>
  <tbody>
  <tr :style="{color: product.stock <= 0 ? 'red':''}"  class="pointer"  :class="`index-${index}`"  v-for="(product,index) in cart" :key="index">
      
      <td><a @click="deleteItem(index)"><i style='color:blueviolet' data-toggle="tooltip" title="Elimina"  class="fa fa-trash" aria-hidden="true"></i></a></td>
      <td>{{index+1}}</td> 
      <td>{{product.orderId}}</td>
       <td>{{product.barcode}}</td>
      
      <td>{{product.brand}}</td>
       <td>{{product.sku}}</td>
      <td>{{product.category}} {{ product.department }}  -  {{product.season}}  {{product.season_year}}
        <div>
          <span><small>{{product.description}}</small></span>
        </div>
      </td>
                       
      <td >{{product.color}}</td>
      <td >{{product.size}}</td>
      <td class="text-right">{{product.stock}}</td>
      <td class="text-right">{{fmt1(product.retail_price)}}</td>
      <td class="text-right">{{getDiscount(product.retail_price,product.price)}}</td>
      <td class="text-right">{{fmt1(product.price)}}</td>
      
    
    </tr> 
    </tbody>  
   
  </table>
</div>


    </div>
   
    </div>
    
    <div class="row ">
      <div class="col text-right">
        <button v-if="company.Id==26" :disabled="total.items==0 || bt_spinner" @click="confirmBox()" type="button" class="btn btn-primary  mr-3">
          <i class="far fa-check-circle mr-1" aria-hidden="true"></i>
          INVIA A STAMPANTE 
          <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
        </button>
      </div>
    </div> 
      
   </div>
 
   <!-- CARD -->
  </div>

  <!-- COL -->
  </div>
  
  <!-- ROW -->
  </div>
    


<!-- div container -->
</div>

</template>

<script>

import api                 from '@/api'
import alertBox            from '@/components/common/AlertBox.vue'
import spinner             from '@/components/common/Spinner.vue'
import mpSelect            from '@/components/common/MPSelect.vue'
import confirmBox          from '@/components/common/ConfirmBox.vue'
import pushState           from '@/components/mixins/pushState'
import fmt                 from '@/components/mixins/fmt'
import { mapGetters }      from 'vuex'
import {setFmtDate1}        from '@/functions'   
import ordersList          from '@/components/admin/OrdersList.vue'


export default {
    
  mixins: [pushState,fmt],
  components: {alertBox,spinner,confirmBox,mpSelect,ordersList
  
  },
  data () 
  {
    return {
     
      mp          :
      {
        Id            : 0,
        disabled      : false,
       
        optionBase    : false,
        required      : true
      },

      orderId         : '',
      barcode         : '',
      orderDate       : new Date().toISOString().slice(0,10),
      orderTime       : new Date().toTimeString().slice(0,5),
      refresh         : 0,
      bt_spinner      : false, 
    
      spinner       : false,
      cart         : [],
      msg          : {
       title : '',
       body  : '',
       type  : 0
     },
    
     
    
     index        : 0,
     boxType      : '',
     cb           : {
       title   : '',
       msg1    : '',
       show    : false
     },
     
     
     refresh       : 0
     

      }
  },
   
  computed: 
  {
    ...mapGetters(['storeId','company']) , 

    total : function() {
   
     
      let  total = {items: 0,total : 0}
      this.cart.forEach(item => {

          total.total  += Number(item.price)
          total.items  += 1
          

      })

      return total
    }
   
    
  },

  mounted : function()
  {
    
   
  },
  
  created: function() 
  {
      
  },

  methods: 
  { 
    getDiscount(price1,price2)
    {
      const total =  (price2 / price1)
     
      return 100 - (total * 100)
    },

    setOrderData()
    {
      const total = this.cart.length
      let index = 0
      //const data = []
      this.cart.forEach(item=>{
        index ++
        const orderQty = index.toString() + '/' + total.toString()  
        item.orderQty  = orderQty
       // item.giftBox  = '-'
        /*
        data.push({"orderId" : item.orderId,
          "orderDate"        : setFmtDate1(item.orderDate),
          "orderTime"        : item.orderTime,
          "nation"           : '*',
          "barcode"          : item.barcode,
          "giftBox"          : "-",
          "orderQty"         : orderQty,
          "price"            : item.price,         
          "mpId"             : item.mpId})
          */
        
      })
      return this.cart
    },
    setMPId(Id)
    {
      
      this.mp.Id = Id
      
    },  
    setConfirmBox()
    {
      
      if(this.cb.type =='C')
      {
        this.sendOrderToPrinter()
      }
      else if(this.cb.type =='D')
      {
        
        this.deleteRow()
      }
      else
      {
        //this.resetCart()
      }
    },

    confirmBox()
    { 
        this.msg.title = ""
        this.cb.type = 'C'
        this.cb.title = 'CONFERMI INVIO ORDINE A STAMPANTE ?' 
        this.cb.msg1 = ''

        this.cb.show = true
       
    },  
   
    async submit()
    {
      
    this.msg.title  = ''
    this.spinner    = true
    const sp        = {'sp':'spOrderToPrinterDataProduct'}    
    const data      = {'barcode' : this.barcode ,'mpId' : this.mp.Id,'companyId':this.company.Id} 
    const json      = Object.assign(data, sp)
    
    await api.post(json).then(res => {
      
      if(res.status==200)
        {

          if(res.data.recordsets[0].length==0)
          {
            this.msg.title = "ATTENZIONE "
            this.msg.body  = "Prodotto inesistente."
            this.msg.type  = 1
                        
            return
          }
          
          this.barcode = ''                    
          this.cart.push(res.data.recordsets[0][0])
          
          const index                = this.cart.length-1                    
          this.cart[index].orderId   = this.orderId
          this.cart[index].orderDate = setFmtDate1(this.orderDate)
          this.cart[index].orderTime = this.orderTime
          this.cart[index].mpId      = this.mp.Id
          this.cart[index].nation    = '*'
          this.cart[index].giftBox   = "-"

          

          this.$nextTick(function () 
                {          
                  this.scrollToElement(index)
                })                                   
                

        }
        else if(res.status==500)
        {
          
          this.msg.title = "ATTENZIONE "
          this.msg.body  = res.data
          this.msg.type  = 1

        } 
        else
        {
          
          this.msg.title = "ATTENZIONE "
          this.msg.body  = res
          this.msg.type  = 1                
          
        } 
    }).catch(err => 
    {
      console.log(err.message)    
    }).finally(() => {
      this.spinner = false
    });
  
    },
    scrollToElement(index) 
    {
      const el = this.$el.getElementsByClassName('index-' + index)[0];
      
      if (el) {
        el.scrollIntoView();
      }
    },
    reset()
    {
      if(this.cart.length>0)
      {
        this.boxType = 'R'
        this.cb.title = 'CONFERMI RESET ORDINE ?'
        this.cb.show = true

      }
    },

   
   async sendOrderToPrinter()
    {
      const data      = this.setOrderData()   
      this.bt_spinner = true
      let arr         = []

      const asyncForEach = async (array, callback) =>
      {
        return new Promise(async(resolve, reject)  =>  {
        for (let index = 0; index < array.length; index++) 
        {
          await callback(array[index]);
        }
        resolve()
        })      
      } 
      //let index = 0
      await asyncForEach(data, async (item) => {         
        return new Promise((resolve, reject)   =>  {
        this.createOrder(item).then(res=>{
          console.log(res)
          resolve()
        }).catch((err) =>{
          
          arr.push(item)
          reject()
          console.log(err)

        })
        //index++
      })
      })
      if(arr.length > 0)
      {
        
        this.msg.title = "ATTENZIONE "
        this.msg.body  = "SI E' VERIFICATO UN ERRORE DURANTE L'INVIO,RIPROVA."
        this.msg.type  = 1
        this.cart = arr
        //console.log(arr)
      }
      else
      {
        this.orderId = ''
        this.mp.Id = 0
        this.cart = []
      }
      this.bt_spinner = false
      //this.refresh++

    },

    
    async createOrder(item)
    { 
      this.msg.title = ''
      const url = process.env.NODE_ENV == 'production' ? 'https://api.studio1-smart.net/sync/caposerio/orders' : 'http://192.168.1.210:5000/sync/caposerio/orders'
      //this.bt_spinner = true
      
      return new Promise(async (resolve, reject) =>  {
      await api.api1(item,url).then(res => {

        if(res.status==200)
          {
            //this.msg.title = "ORDINE INVIATO."
            //this.msg.body  = ""
            //this.msg.type  = 0
          
          //this.cart      = []         
          resolve(res)
          }
          else if(res.status==500)
          {
          
            this.msg.title = "ATTENZIONE "
            this.msg.body  = res.data
            this.msg.type  = 1
            reject(res.data)
          } 
          else
          {
            
            this.msg.title = "ATTENZIONE "
            this.msg.body  = res
            this.msg.type  = 1                             
            reject(res)
          } 
      }).catch(err => 
      {
        console.log('catch',err)    
        reject(err)
      }).finally(() => {
        //this.bt_spinner = false
      });


    }) 

    },
  
    resetCart()
    {
            
      this.cart = []
      
    },
  
    deleteRow()
    {
      this.cart.splice(this.index, 1);      
    },
    deleteItem(index)
    {
      const row     = index + 1
      this.cb.type  = 'D'
      this.cb.title = 'CONFERMI ELIMINAZIONE RIGA : ' + row
      this.index    = index 
      this.cb.show  = true
      
    },

 

 
}
}
</script>
<style scoped>



.table-wrapper-scroll-y {
  display: block;
}

.table-scrollBar
{
  height     :400px;  
  overflow   :scroll;
  overflow-x : hidden;
  
}

.my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }

.pointer:hover
{
  background-color : lightblue(182, 216, 241, 0.972);
  color            : black;
  cursor           : pointer;
}

.cart thead tr:nth-child(1) th
 {
  
    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;
   
    position   : sticky;
    top        : 0;
    z-index    : 10;

 }
 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

 


h4,p {

  font-size    : 20px;
}

.pointer
{
  cursor       : pointer;
}
.cart th:first-child
{
  border-radius : 0 0 0 8px;
}
.cart th:last-child
{
  border-radius : 0 8px 0 0;  
}

.modal-footer {  
  justify-content: space-between;  
}

.card-header
{
  height: 45px;
}
</style>